import React, { Component } from 'react'
import MasterDetailLayout from 'components/MasterDetailLayout'
import Header from 'components/Header'
import Hamburger from 'components/Hamburger'
import AddButton from 'components/AddButton'
import ProjectsTable from './Table'
import ProjectForm from '../projectForm'
import FiltersPicker from 'components/FiltersPicker'
import Notifications from 'components/ListLayoutParts/Notifications'
import Search from 'components/Search'

export default class ProjectsPage extends Component {
	render() {

		let { props } = this
		let detailID = props.routeParams.id
		let header = (style) => (
			<Header {...{style}}>
				<Hamburger />
				<div>
					<FiltersPicker entity={'project'} />
					<Notifications />
					<div style={{
							float: "right"
						  , position: "relative"
						  , top: "-24px"
						  , left: "240px"}}
					>
						<Search  entity={'project'} id="search-projects" style={{marginTop: "-8px"}}/><
					/div>
				</div>
				<AddButton object={{type:'project'}} color="#FFF" detailID={detailID}/>
			</Header>
		)
		return(
			<MasterDetailLayout
				header={header}
				master={props => <ProjectsTable {...props} detailID={detailID} />}
				detail={props => <ProjectForm {...props} id={detailID} />}
				detailColumns={2}
				detailOpen={!!detailID}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/routes/manager/projects/index.js